import axios from 'axios';
import { handleRequest } from '../../helpers/api';

const VISITOR_URL = `${process.env.REACT_APP_API_URL}/visitors`;

axios.defaults.withCredentials = true;

const visitorApi = axios.create({
  baseURL: VISITOR_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface TrackVisitor {
  url: string;
}

export const addtrackVisitor = async (track: TrackVisitor) => {
  return handleRequest(visitorApi.post('/track-visitor', track));
};

export const addtrackVisitorpublic = async (track: TrackVisitor) => {
  return handleRequest(visitorApi.post('/track-visitor-public', track));
};
